import {Trans} from 'react-i18next';
import React from 'react';
import smbUtils from '../../utils/smbUtils';
import langUtils from '../../utils/langUtils';
import i18n from '../../utils/i18n';

export default function ModalContent() {
  const prefix =
    smbUtils.getUrl() + langUtils.convertToFrontendLangUrl(i18n.language);
  const onlineServicePage = `${prefix}/business/solutions/online-service`;
  return (
    <div>
      <Trans i18nKey="expired.trial.desc1">
        We hope you've enjoyed using our virtual try-on service so far. We are
        happy to let you know that a <strong>free update</strong> of the console
        is ready for you to enjoy.
      </Trans>
      <br />
      <br />
      <Trans i18nKey="expired.trial.desc2">
        <strong>What’s NEW?</strong>
      </Trans>
      <br />
      <br />
      <ul>
        <Trans i18nKey="expired.trial.desc3">
          <li>
            <strong>The all-new Virtual Try-on Widget.</strong> A new method to
            bring the virtual makeup experience to your customers.
          </li>
        </Trans>
        <br />
        <Trans i18nKey="expired.trial.desc4">
          <li>
            <strong>Simplified integration process.</strong> We made integration
            as simple as copy/paste autogenerated code segments to your web
            pages.
          </li>
        </Trans>
        <br />
        <Trans i18nKey="expired.trial.desc5">
          <li>
            <strong>Better virtual product discoveries.</strong> The new widget
            eliminates the need for mapping product try-ons to your web pages.
          </li>
        </Trans>
        <br />
      </ul>
      <Trans i18nKey="expired.trial.desc6">
        <strong> See the NEW Online Service’s</strong>{' '}
        <a href={onlineServicePage} className='kt-link'>complete list of enhancements.</a>{' '}
      </Trans>
      <br />
      <br />
    </div>
  );
}
